import './style.scss'

const BetaBadge = () => {
	return <span className='beta-badge'>BETA</span>
}

export default BetaBadge